import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client/react";

export const GET_KYC_VENDOR_INFORMATION = gql`
  query ($vendorInquiryId: ID!) {
    unauthenticated {
      kyc {
        vendor_inquiry(id: $vendorInquiryId) {
          __typename
          ... on VendorInquiryResult {
            id
            user_id
            vendor
            vendor_id
            vendor_token
          }
          ... on GenericError {
            title
            message
            dev_message
          }
        }
      }
    }
  }
`;

export const GET_USER_PRIVACY_CONSENT = gql`
  query GetNotice($external_id: ID!) {
    unauthenticated {
      scan_id {
        consent(external_id: $external_id) {
          __typename
          notice
          show_consent
        }
      }
    }
  }
`;

type VendorInquiryResult = {
  __typename: "VendorInquiryResult";
  id: string;
  user_id: string;
  vendor: string;
  vendor_id: string;
  vendor_token: string;
};

type GenericError = {
  __typename: "GenericError";
  title: string;
  message: string;
  dev_message: string;
};

type GetKycVendorInformationData = {
  unauthenticated?: {
    kyc?: {
      vendor_inquiry?: VendorInquiryResult | GenericError | undefined;
    };
  };
};

type GetKycVendorInformationVars = { vendorInquiryId: string };

type GetUserPrivacyConsentData = {
  unauthenticated?: {
    scan_id?: {
      consent?: { __typename: string; notice: string; show_consent: boolean };
    };
  };
};

type GetUserPrivacyConsentVars = { external_id: string };

// Custom Hook for KYC Vendor Information
export function useKYCVendorInformation(id: string) {
  return useQuery<GetKycVendorInformationData, GetKycVendorInformationVars>(GET_KYC_VENDOR_INFORMATION, {
    variables: {
      vendorInquiryId: id,
    },
  });
}

// Custom Hook for Privacy User Consent
export function usePrivacyUserConsent(id: string) {
  return useQuery<GetUserPrivacyConsentData, GetUserPrivacyConsentVars>(GET_USER_PRIVACY_CONSENT, {
    variables: {
      external_id: id,
    },
  });
}
